import * as React from 'react';
import { CircularProgress } from '@material-ui/core';

import { Typography } from 'components/v2';
import CancelButtonContainer from '../CancelButtonContainer';

const CancelButtonLoading = () => (
  <CancelButtonContainer disabled>
    <Typography variant="bW600F14" color="inherit" noWrap>
      <CircularProgress size={21} />
    </Typography>
  </CancelButtonContainer>
);

export default CancelButtonLoading;
